const Context = window.wp.element.createContext({});

export default Context;
